import { render, staticRenderFns } from "./ApplicationSettings.vue?vue&type=template&id=136f1480"
import script from "./ApplicationSettings.vue?vue&type=script&lang=js"
export * from "./ApplicationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports